import 'focus-within-polyfill';

import './global/jquery-migrate';
import './common/select-option-plugin';
import PageManager from './page-manager';
import quickSearch from './global/quick-search';
import currencySelector from './global/currency-selector';
import mobileMenuToggle from './global/mobile-menu-toggle';
import menu from './global/menu';
import foundation from './global/foundation';
import quickView from './global/quick-view';
import cartPreview from './global/cart-preview';
import privacyCookieNotification from './global/cookieNotification';
import carousel from './common/carousel';
import svgInjector from './global/svg-injector';
import jamersanGlobal from './global/jamersan-global';
import emrnBuyerPortal from './global/emrn-buyer-portal';
import './emrn-smart-search';

function syncAriaHiddenFocusables(root = document) {
    const focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';
    const hiddenContainers = [];
    const visibleContainers = [];

    if (root.matches && root.matches('[aria-hidden="true"]')) hiddenContainers.push(root);
    if (root.matches && root.matches('[aria-hidden="false"]')) visibleContainers.push(root);

    root.querySelectorAll('[aria-hidden="true"]').forEach((el) => hiddenContainers.push(el));
    root.querySelectorAll('[aria-hidden="false"]').forEach((el) => visibleContainers.push(el));

    hiddenContainers.forEach((hiddenContainer) => {
        hiddenContainer.querySelectorAll(focusableSelector).forEach((el) => {
            if (!el.dataset.emrnOriginalTabindex) {
                el.dataset.emrnOriginalTabindex = el.getAttribute('tabindex') || '__none__';
            }

            el.setAttribute('tabindex', '-1');
        });
    });

    visibleContainers.forEach((visibleContainer) => {
        visibleContainer.querySelectorAll('[data-emrn-original-tabindex]').forEach((el) => {
            const original = el.dataset.emrnOriginalTabindex;

            if (original === '__none__') {
                el.removeAttribute('tabindex');
            } else {
                el.setAttribute('tabindex', original);
            }

            delete el.dataset.emrnOriginalTabindex;
        });
    });
}

function observeAriaHiddenFocusables() {
    syncAriaHiddenFocusables();

    if (!window.MutationObserver) return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            const target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : document;
            syncAriaHiddenFocusables(target.closest ? (target.closest('[aria-hidden]') || target) : document);
        });
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        childList: true,
        subtree: true,
    });
}

export default class Global extends PageManager {
    onReady() {
        const {cartId, secureBaseUrl} = this.context;
        cartPreview(secureBaseUrl, cartId);
        quickSearch();
        currencySelector(cartId);
        foundation($(document));
        quickView(this.context);
        carousel(this.context);
        menu();
        mobileMenuToggle();
        privacyCookieNotification();
        svgInjector();
        jamersanGlobal();
        emrnBuyerPortal();
        observeAriaHiddenFocusables();
    }
}
